<div>
    <div class="p-5">
        <!--basic-info begin-->
        <div class="grid">
            <div class="border-top-1 py-2 col-6 border-gray-300">
                <span class="font-bold mr-2 w-3 inline-block">{{'task.priority' | translate}}</span>
                <span class="text-gray-600 border-left-1 border-gray-300 pl-2">Medium</span>
            </div>
            <div class="border-top-1 py-2 col-6 border-gray-300">
                <span class="font-bold mr-2 w-3 inline-block">{{'task.state' | translate}}</span>
                <span class="text-gray-600 border-left-1 border-gray-300 pl-2">{{ tasks[0].state }}</span>
            </div>
            <div class="border-top-1 border-bottom-1 py-2 col-6 border-gray-300">
                <span class="font-bold mr-2 w-3 inline-block">{{'task.sent-by' | translate}}</span>
                <span class="text-gray-600 border-left-1 border-gray-300 pl-2"></span>
            </div>
            <div class="border-top-1 border-bottom-1 py-2 col-6 border-gray-300">
                <span class="font-bold mr-2 w-3 inline-block">{{'task.target-date' | translate}}</span>
                <span class="text-gray-600 border-left-1 border-gray-300 pl-2">{{ tasks[0].targetDate }}</span>
            </div>
        </div>
        <!--basic-info end-->
        <!--content-field begin-->
        <div class="flex flex-column mt-5">
            <span class="py-2 font-bold border-bottom-1 border-gray-300">{{'task.content' | translate}}</span>
            <span class="py-2 text-gray-600">As a driver, I need to mark my ride as finished</span>
        </div>
        <!--content-field end-->
        <!--acceptance-info begin-->
        <div class="flex flex-column mt-5">
            <div class="py-2 flex justify-content-between mb-3 border-bottom-1 border-gray-300">
                <span class="font-bold">{{'task.acceptance-info' | translate}}</span>
            </div>
            <p-accordion [activeIndex]="" (onOpen)="toggleAccordionHeader()" (onClose)="toggleAccordionHeader()">
                <p-accordionTab>
                    <ng-template pTemplate="header">
                        <div class="pl-2 flex align-items-center">
                            <div class="font-bold">{{ accordionHeader }}</div>
                        </div>
                    </ng-template>
                    <div class="flex flex-column px-1">
                        <span class="py-1 text-gray-600">The driver is able:</span>
                        <span class="py-1 text-gray-600">-mark a started ride as finished</span>
                        <span class="py-1 text-gray-600">-enter the received price/tip</span>
                        <span class="py-1 text-gray-600">-rate the customer</span>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>
        <!--acceptance-info end-->
        <!--result-field begin-->
        <div class="flex flex-column mt-5">
            <span class="py-2 font-bold border-bottom-1 border-gray-300 mb-3">{{'task.result' | translate}}</span>
            <div class="text-gray-400 cursor-pointer border-1 border-round-lg w-full p-3" *ngIf="!isWriteResultOpen"
                 (click)="openResult()">{{'task.write-a-result' | translate}}
            </div>
            <div *ngIf="isWriteResultOpen">
                <p-editor class="py-2" [(ngModel)]="resultText" [style]="{ height: '120px' }"/>
                <div class="pt-3 flex justify-content-end">
                    <p-button>{{'task.submit-result' | translate}}</p-button>
                </div>
            </div>
        </div>
        <!--result-field end-->
        <!--files begin-->
        <div class="flex flex-column mt-5">
            <div class="flex justify-content-between py-2 align-items-center border-bottom-1 border-gray-300">
                <span class="font-bold">{{'task.files' | translate}}</span>
                <span class="font-bold text-3xl text-gray-500 pr-3 cursor-pointer relative hover:text-gray-900">
                    +
                    <input type="file" class="absolute left-0 pt-2 h-full opacity-0">
                </span>
            </div>
            <div class="flex flex-column py-2">
                <ng-container *ngIf="files.length">
                    <span class="p-2" *ngFor="let file of files">{{ file }}</span>
                </ng-container>
            </div>
        </div>
        <!--files end-->
        <!--subtasks begin-->
        <div class="flex flex-column mt-5">
            <span class="border-bottom-1 border-gray-300 py-2 font-bold mb-2">{{'task.subtasks' | translate}}</span>
            <p-accordion [multiple]="true" [activeIndex]="">
                <p-accordionTab *ngFor="let subtask of tasks[0].subtasks">
                    <ng-template pTemplate="header">
                        <div class="pl-2 flex align-items-center">
                            <app-task-status-icon [status]="subtask.status"></app-task-status-icon>
                            <div class="pl-3">{{ subtask.no }}</div>
                        </div>
                    </ng-template>
                    <div class="flex flex-wrap px-3">
                        <span class="py-1 text-gray-600 w-3">{{'task.task-name' | translate}}:</span>
                        <span class="py-1 text-gray-600 w-9">{{ subtask.title }}</span>
                        <span class="py-1 text-gray-600 w-3">{{'task.target-date' | translate}}:</span>
                        <span class="py-1 text-gray-600 w-9">{{ subtask.targetDate }}</span>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>
        <!--subtasks end-->
        <!--comment-field begin-->
        <div class="flex flex-column mt-5 mb-5">
            <span class="py-2 font-bold border-bottom-1 border-gray-300 mb-3">{{'task.comments' | translate}}</span>
            <div class="text-gray-400 cursor-pointer border-1 border-round-lg w-full p-3" *ngIf="!isCommentOpen"
                 (click)="openComment()">{{'task.write-a-comment' | translate}}
            </div>
            <div *ngIf="isCommentOpen">
                <p-editor class="py-2" [(ngModel)]="commentText" [style]="{ height: '120px' }"/>
                <div class="pt-3 flex justify-content-end">
                    <p-button>{{'task.submit-comment' | translate}}</p-button>
                </div>
            </div>
        </div>
        <div class="py-3 px-4 border-bottom-1 border-gray-300" *ngFor="let comment of comments">
            <div class="font-bold">{{ comment.comment }}</div>
            <div class="flex justify-content-between align-items-end">
                <span class="text-gray-500 inline-block pb-1 pt-4 w-3">{{ comment.user }}</span>
                <span class="text-gray-500 inline-block pb-1 pt-4 w-8">{{ comment.date }}</span>
                <i class="text-red-400 pi pi-trash cursor-pointer w-1"></i>
            </div>
        </div>
        <!--comment-field end-->
    </div>
</div>
